const StoreLocationsSection = () => {
  return (
    <section className="w-full bg-white py-16 px-6 lg:px-16 ">
      <div className="max-w-7xl mx-auto text-center space-y-6 lg:flex lg:items-center lg:justify-center">
        <div>
          <h2 className="text-2xl lg:text-4xl font-bold text-gray-800">
            Hệ Thống Cửa Hàng
          </h2>
          <p className="text-md text-gray-600">
            253 Hùng Vương, TP. Tam Kỳ, Quảng Nam
          </p>
        </div>
        <img
          src={
            "https://res.cloudinary.com/dyxwbtohw/image/upload/v1735612466/AboutUs/c7bxvpf9ri0frrz7gn8x.jpg"
          }
          alt="Store Locations"
          className="w-full lg:w-[30%] mx-auto rounded-lg shadow-lg"
        />
      </div>
    </section>
  );
};

export default StoreLocationsSection;
